export default "__VITE_ASSET__CA9jW7sQ__"